export default "__VITE_ASSET__936b1653__"